import { ChangeDetectionStrategy, Component, computed, effect, HostBinding, input, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { iconsRegistry } from './icons-registry';
import { IconName } from '../../types/icon-name.type';
import { ResponsiveSize } from '../../types/responsive-size.type';
import { ResponsiveSizeDirective } from '../../directives/responsive-size.directive';

@Component({
  selector: 'outlaw-icon',
  styleUrl: './icon.component.scss',
  template: `
    <span class="svg-icon" [innerHTML]="sanitizedSvg()"></span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: ResponsiveSizeDirective,
      inputs: ['responsiveSize: size'],
    },
  ],
})
export class IconComponent {
  readonly name = input.required<IconName>();
  readonly size = input<ResponsiveSize>('16px');
  readonly width = input<string | number>();
  readonly height = input<string | number>();
  readonly color = input<string>('currentColor');

  private readonly rawSvg = signal<string>('');
  protected readonly sanitizedSvg = computed<SafeHtml>(() => {
    const svg = this.rawSvg();
    return svg ? this.sanitizer.bypassSecurityTrustHtml(svg) : '';
  });

  @HostBinding('style.--width-override')
  get widthOverride(): string | null {
    const w = this.width();
    return w !== undefined ? this.normalizeSize(w) : null;
  }

  @HostBinding('style.--height-override')
  get heightOverride(): string | null {
    const h = this.height();
    return h !== undefined ? this.normalizeSize(h) : null;
  }

  @HostBinding('style.color')
  get hostColor(): string {
    return this.color();
  }

  constructor(private readonly sanitizer: DomSanitizer) {
    effect(() => {
      const iconName = this.name();
      const svg = iconsRegistry[iconName];

      if (!svg) {
        console.warn(
          `[IconComponent] Иконка "${iconName}" не найдена в реестре. Доступные иконки:`,
          Object.keys(iconsRegistry)
        );
        this.rawSvg.set('');
        return;
      }

      this.rawSvg.set(svg);
    });
  }

  private normalizeSize(size: string | number): string {
    return typeof size === 'number' ? `${size}px` : size;
  }
}
